export const parseInteger = (value, defaultValue) => {
  const n = parseInt(String(value).trim(), 10);
  return Number.isNaN(n) ? defaultValue : n;
};

export const getFieldErrorMessage = (errors, fieldKey) => {
  const value = errors?.[fieldKey];
  return Array.isArray(value) ? value.join(", ") : value;
};
